<template>
  <span
    :class="['badge', 'text-white', paymentMethods[paymentMethod].class]" v-bind="$attrs"
  >
    {{ paymentMethods[paymentMethod].text }}
  </span>
</template>

<script>
export default {
  props : {
    paymentMethod : {}
  },

  data: () => ({
    paymentMethods: {
      1: {
        text: "Dinheiro",
        class: "badge-success",
      },

      2: {
        text: "Cheque",
        class: "badge-secondary",
      },

      3: {
        text: "Cartão de Credito",
        class: "badge-secondary",
      },
      4: {
        text: "Cartão de Débito",
        class: "badge-secondary",
      },
      5: {
        text: "Crediário",
        class: "badge-secondary",
      },

      15: {
        text: "Boleto Bancário",
        class: "badge-secondary",
      },
      16: {
        text: "Depósito Bancário",
        class: "badge-secondary",
      },
      17: {
        text: "Pix",
        class: "badge-secondary",
      },
      18: {
        text: "Carteira Digital ",
        class: "badge-secondary",
      },
      99: {
        text: "Outros",
        class: "badge-secondary",
      },
    },
  }),
};
</script>

<style>
</style>